import React from 'react';

import { EuiToast } from '../../../../src/components';

export default () => (
  <EuiToast
    title="Sometimes a title is enough!"
    color="warning"
    iconType="warning"
  />
);
